import * as THREE from 'three';

const BOX = new THREE.Box3();
const SIZE = new THREE.Vector3();


export default function getModelHeight(mesh: THREE.Mesh) {
    BOX.setFromObject(mesh);
    BOX.getSize(SIZE);
    return SIZE.y;
}
